import { render } from "./RadioInput.vue?vue&type=template&id=37d3b070"
import script from "./RadioInput.vue?vue&type=script&lang=js"
export * from "./RadioInput.vue?vue&type=script&lang=js"

import "./RadioInput.vue?vue&type=style&index=0&id=37d3b070&lang=css"

import exportComponent from "/var/www/html/auditoria/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__